module.exports = __webpack_public_path__ + "img/dku.00111.c86cd0dc.png";